<template>
	<SOSlotBase container-name="container-sorting-mesin">
		<template v-slot:title-bar>
			<SOTitleBar type="back" page-title="Sorting Mesin" @back="back"/>
		</template>
		<template v-slot:content v-if="!loading">
			<div class="p-t-16 vh-100 d-grid-12">
				<div class="p-x-20 grid-cspan-12" style="
    margin-bottom: 100px ;">

					<div class="content-wrapper f-regular f-14 d-block">
						<div class="urut_info" style="
    font-size: 18px;
    margin: 10px 0px;
">
							<b>Cara Mengurutkan : </b> Tekan dan Tahan icon <img
							src="../../../../assets/img/menu-out.svg"> kemudian geser ke atas/bawah.
						</div>
						<div class="row">
							<div class="col-md-6">
								<h3>Washer</h3>
								<div class="row">
									<div class="col-2 col_no_urut">
										<div class="no_urut no_urut_washer" v-for="(element,x) in washer"
										     :key="element.order">
											<span class="">W{{ padNumber(x+1) }}</span>
										</div>
									</div>
									<div class="col-md-9 col-10 col_item_urut">
										<draggable class="list-group" tag="ul" v-model="washer" handle=".handle-washer"
										           v-bind="dragOptions" :move="onMove"
										           @start="isDragging=true" @end="isDragging=false">
											<transition-group type="transition" :name="'flip-list'">
												<li class="list-group-item item_urut" v-for="element in washer"
												    :key="element.idmesin">
													{{ element.nama }}
													<div class="handle-washer">
														<img src="../../../../assets/img/menu-out.svg"
														     alt=""
														>
													</div>

												</li>
											</transition-group>
										</draggable>
									</div>
								</div>

							</div>
							<div class="col-md-6">
								<h3>Dryer</h3>
								<div class="row">
									<div class="col-2 col_no_urut">
										<div class="no_urut no_urut_dryer" v-for="(element,x) in dryer"
										     :key="element.order">
											<span class="">D{{padNumber(x+1)}}</span>
										</div>
									</div>
									<div class="col-md-9 col-10 col_item_urut">
										<draggable class="list-group" tag="ul" v-model="dryer" v-bind="dragOptions"
										           :move="onMove"
										           @start="isDragging=true" @end="isDragging=false"
										           handle=".handle-dryer">
											<transition-group type="transition" :name="'flip-lists'">
												<li class="list-group-item item_urut" v-for="element in dryer"
												    :key="element.idmesin">
													{{ element.nama }}
													<div class="handle-dryer"
													>
														<img src="../../../../assets/img/menu-out.svg"
														     alt=""
														>

													</div>

												</li>
											</transition-group>
										</draggable>
									</div>
								</div>

							</div>
						</div>

					</div>

				</div>
			</div>
			<div class="nav-btn-urut">
					<div class="content-item">
						<SOButton
							:full="true"
							:primary="true"
							text="Simpan"
							@action="updateMesinSorting"
						/>
					</div>
			</div>
		</template>
		<template v-slot:skeleton>
			<SOLoadingPage v-if="loading"/>
		</template>
	</SOSlotBase>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOInputRadioBig from "@/so-components/global/input/SOInputRadioBig";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOButton from "@/so-components/global/ui/SOButton";
import {mapGetters} from "vuex";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import ErrorMessage from "@/component-items/ErrorMessage";
import {minLength, required} from "vuelidate/lib/validators";
import SOInputSelectMultiple from "@/so-components/global/input/SOInputSelectMultiple";
import draggable from 'vuedraggable'

const message = [
	"vue.draggable",
	"draggable",
	"component",
	"for",
	"vue.js 2.0",
	"based",
	"on",
	"Sortablejs"
];
export default {
	name: "SnapMesinSorting",
	components: {
		SOInputSelectMultiple,
		ErrorMessage,
		SOLoadingPage,
		SOButton,
		SOInputSelect,
		SOInputRadioBig,
		SOInputRegular,
		SOTitleBar,
		SOSlotBase,
		draggable,
	},
	data() {
		return {
			washer: [],
			dryer: [],
			myArray: [{id: "1", "name": "A"}, {id: "2", "name": "B"}],
			loading: false,
			idoutlet: "",
			idmesin: "",
			tag: [],
			kategoriMesin: [],
			input: {
				nama: "",
				jenis: 1,
				door: 1,
				tag: "",
			},
			radioJenis: [
				{
					title: "Mesin Cuci",
					name: "jenis-mesin",
					value: "1",
					id: "mc",
				},
				{
					title: "Mesin Pengering",
					name: "jenis-mesin",
					value: "2",
					id: "mp",
				},
			],
			radioSensor: [
				{
					title: "Ada",
					name: "sensor",
					value: "1",
					id: "sa",
				},
				{
					title: "Tidak Ada",
					name: "sensor",
					value: "0",
					id: "st",
				},
			],
		};
	},
	validations: {
		input: {
			nama: {
				required,
				minLength: minLength(2),
			},
			tag: {
				required,
			},
		},
	},
	methods: {
		padNumber(number) {
			return number.toString().padStart(2, '0')
		},
		onMove({relatedContext, draggedContext}) {
			const relatedElement = relatedContext.element;
			const draggedElement = draggedContext.element;
			return (
				(!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
			);
		},
		back() {
			this.$router.push({
				name:
					  "ListSnapMesin",
				query: {
					idoutlet: this.idoutlet,
				},
			});
		},


		async fetchListMesinUrut() {
			this.loading=true
			const res = await this.$store.dispatch(
				"snapMesinModule/fetchListMesinUrut",
				this.idoutlet
			);
			if (res.success) {
				this.loading=false;
				console.log(res.success)

				this.listMesinUrut.data.washer.forEach((element)=>{
					this.washer.push({
						"idmesin":element.id,
						"nama":element.nama,
						"urutan":element.urutan
					});
				})
				this.listMesinUrut.data.dryer.forEach((element)=>{
					this.dryer.push({
						"idmesin":element.id,
						"nama":element.nama,
						"urutan":element.urutan
					});
				})
				// this.washer=this.listMesinUrut.data.washer
				// this.dryer=this.listMesinUrut.data.dryer
			} else {
				this.loading=false;
				this.$toast.error(res.err);
			}
		},
		validateError() {
			this.$v.input.nama.$touch();
			this.$v.input.tag.$touch();
			return this.$v.input.nama.$invalid || this.$v.input.tag.$invalid;
		},

		async updateMesinSorting() {
			this.loading=true;
			let payload = {
				idoutlet: this.idoutlet,
				data:{
					"washer":this.washer,
					"dryer":this.dryer,
				}

			};

			const res = await this.$store.dispatch(
				"snapMesinModule/updateMesinSorting",
				payload
			);
			if (res.success) {
				this.loading=false;
				this.$toast.success(res.msg.msg);
				this.back();
			} else {
				this.loading=false;
				this.$toast.error(res.msg.msg);
			}
		},
	},
	mounted() {
		this.idoutlet = this.$route.params.idoutlet;
		 this.fetchListMesinUrut()
	},
	async beforeDestroy() {
		await this.$store.commit("snapMesinModule/resetDetail");
	},
	computed: {
		...mapGetters("snapMesinModule", {
			listMesinUrut: "getListMesinUrut",
		}),
		dragOptions() {
			return {
				animation: 10,
				// group: "description",
				ghostClass: "ghost"
			};
		},

	},
	watch: {
		isDragging(newValue) {
			if (newValue) {
				this.delayedDragging = true;
				return;
			}
			this.$nextTick(() => {
				this.delayedDragging = false;
			});
		}
	}
};
</script>

<style scoped>
.flip-list-move {
	transition: transform 0.5s;
}

.no-move {
	transition: transform 0s;
}

.ghost {
	opacity: 0.5;
	background: #c8ebfb;
}

.list-group {
	min-height: 20px;
}

.list-group-item {
	//cursor: move;
}



.list-group-item i {
	cursor: pointer;
}

.badge {
	display: inline-block;
	min-width: 10px;
	padding: 3px 7px;
	font-size: 12px;
	font-weight: bold;
	line-height: 1;
	color: #fff;
	text-align: center;
	white-space: nowrap;
	vertical-align: middle;
	background-color: #777;
	border-radius: 10px;
}

.no_urut {
	position: relative;
	display: block;
	padding: 10px 10px;
	margin-bottom: -1px;
	font-weight: bold;
	text-align: right;
}

.no_urut_washer {
	background-color: #3B73B9;
	border: 1px solid #ffffffa3;
	color: #fff;

}

.no_urut_dryer {
	background-color: #54A275;
	border: 1px solid #ffffffa3;
	color: #fff;

}

.col_no_urut {
	padding-right: 0;

}

.col_item_urut {
	padding: 0;
	padding-right: 15px;

}


li.list-group-item.item_urut {
	padding: 10px;
	border: solid 1px #3B73B9;
}

.no_urut, .item_urut {
	font-size: 18px;
	height: 50px;
}

.handle-dryer, .handle-washer {
	float: right;
//background: #aaa; margin: -10px -10px 10px;
	padding: 12px 15px 12px 15px;
	cursor: move;
}
.nav-btn-urut{

	position: fixed;
	bottom: 80px;
	z-index: 99999;
	right: 0;
	 width: 100%;
	padding-left: 20px;
	padding-right: 20px;
	background: #fff;
	border-top: solid 1px #cccccc;

}
.body-open .nav-btn-urut{

	width: calc(100% - 330px);
}

.view-iframe .nav-btn-urut{
	bottom: 0px;

}
</style>